import { SNACKBAR_SKIN } from 'components/shared/Snackbar';
import { showSnackbar } from 'hooks/useSnackbar';

import { getFileByTask, getFileDownloadingConfig, getTaskId, isDownloadingInProgress } from './downloadingTaskManager';
import { ITask, ITaskConfig } from './types';

type Arguments = {
  id?: string;
  urls: {
    create: () => string;
    ping: (taskId: string) => string;
    download: (taskId: string) => string;
  };
  title: string;
  data: Parameters<typeof getTaskId>[0];
  statuses?: ITaskConfig['statuses'];
  translate?: boolean;
};

export async function saveAsZIP({ id, urls, title, data, translate = false }: Arguments) {
  if (id && isDownloadingInProgress(id)) {
    return;
  }

  try {
    const createTaskURL = urls.create();
    const taskId = await getTaskId(data, createTaskURL);
    const sessionData: ITask = {
      extension: 'zip',
      itemId: id,
      queue: createTaskURL,
      taskId,
      time: Date.now(),
      title,
      createTaskURL,
      pingTaskURL: urls.ping(taskId),
      downloadURL: urls.download(taskId),
    };
    await getFileByTask(getFileDownloadingConfig(sessionData, translate), sessionData);
  } catch (e) {
    window.console.log('Error occurred:', e);

    //@ts-ignore
    showSnackbar({ text: 'Generating archive error. Please, try again.', type: SNACKBAR_SKIN.ERROR });
  }
}
